'use strict';

DoohApps
    .factory('AdminControllerHelper', ['$rootScope', '$filter', '$locale', 'CompanyBLL', 'DialogHandler', 'adminBLL',
        function ($rootScope, $filter, $locale, _company, DialogHandler, _admin) {

    return {
        SetDateFormat: function () {
            if (localStorage['DateFormat']) {
                $rootScope.DATE_FORMAT = localStorage['DateFormat'];
                $rootScope.SHORT_DATE = localStorage['ShortDateFormat'];
                $rootScope.TIMEFORMAT = localStorage['TimeFormat'];
            }
            else {
                $rootScope.DATE_FORMAT = localStorage['DateFormat'] = $locale.DATETIME_FORMATS.shortDate + ' ' + $locale.DATETIME_FORMATS.shortTime;
                $rootScope.SHORT_DATE = localStorage['ShortDateFormat'] = $locale.DATETIME_FORMATS.shortDate;
                $rootScope.TIMEFORMAT = localStorage['TimeFormat'] = $locale.DATETIME_FORMATS.shortTime;
            }
            $rootScope.SHORT_DATE_MOMENT = $rootScope.SHORT_DATE.replace(/d/g, 'D').replace(/y/g, 'Y');
        },
        AddCompany: function (editCompany, selectNewCompany, selectNewCompObj, scope, modal) {
            var successCallback;
            if (selectNewCompany)
                successCallback = function () { return scope.SelectNewCompany(selectNewCompObj); };
            if (modal.open('newCompany', 'inviteColleagueModal', 'static', { resolvedCallback: successCallback })) {
                scope.selectNewCompany = selectNewCompany;
                scope.formError = '';
                scope.newCompany = {};
                if (editCompany != undefined) {
                    scope.newCompany.edit = true;
                    scope.newCompany.CompanyID = editCompany.CompanyID;
                    scope.newCompany.Domain = editCompany.Domain;
                    scope.newCompany.Address = editCompany.Address;
                    scope.newCompany.PhoneNumber = editCompany.PhoneNumber;
                    scope.newCompany.IsAppProvider = editCompany.IsAppProvider;
                    scope.newCompany.Title = editCompany.CompanyName;
                    scope.newCompany.OldTitle = editCompany.CompanyName;
                    scope.newCompany.LogoURL = editCompany.LogoURL == null ? '' : editCompany.LogoURL;
                }
                else {
                    if (scope.selectedUser != undefined) {
                        if (scope.selectedUser.Company == undefined) {
                            var splitEmail = scope.selectedUser.Email.split('@');
                            scope.newCompany.Domain = splitEmail[1];
                            scope.newCompany.Title = splitEmail[1];
                        }
                    }

                    scope.newCompany.edit = false;
                }
            }
        },
        SaveNewCompany: function (scope, modal) {
            if (scope.forms.companyForm.$valid && !scope.FormSent && !scope.saving) {
                scope.FormSent = true;
                scope.saving = true;
                _company.addCompany(function (data) {
                    if (data.error_description != undefined) {
                        DialogHandler.AddError(data.error_description);
                    }
                    else {
                        scope.newCompany.CompanyID = data.Data.Content;
                        if (!scope.selectNewCompany) {
                            getCompanyList(false, scope);
                            scope.getCompanies();
                        }
                        modal.close('newCompany');
                        DialogHandler.AddMessage('Company created!');
                    }
                    scope.saving = false;
                    scope.FormSent = false;
                }, scope.newCompany);
            }
            else {
                scope.formError = 'Validation Error!';
            }
        },
        GetCompanyList: function (scope, withUnregistered) {
            getCompanyList(withUnregistered, scope);
        },
        GetAllAppList: function (scope) {
            getAllAppList(scope);
        },
        GetVendorList: function (scope) {
            getVendorList(scope);
        },
    }

    function getCompanyList(withUnregistered, scope) {
        //GetAllCompanyList
        _company.getAllCompanyList(function (data) {
            if (data.hasError) {
                DialogHandler.AddError('Could not load company list!');
            }
            else {
                scope.CompanyList = data.content;
                if (withUnregistered) {
                    scope.CompanyListFull = angular.copy(data.content);
                    scope.CompanyListFull.unshift({ 'CompanyID': null, 'Title': 'Unregistered' })
                }
			}
        });
    }

    function getAllAppList(scope) {
        scope.appListLoading = true;
        _admin.GetAllApps(function (data) { scope.AppList = data; scope.appListLoading = false; });
    }
    function getVendorList(scope) {
        _company.getVendorList(function (data) {
            scope.vendorList = data;
        });
    }

}]);